export default {
  setValidationErrors (state, payload) {
    state.validationErrors = payload
  },
  setOverlay (state, payload) {
    state.overlay = payload
  },
  setHeader (state, payload) {
    state.header = payload
  },
  setFooter (state, payload) {
    state.footer = payload
  },
  setSubscriptionStatus (state, payload) {
    state.subscriptionStatus = payload
  }
}
